import React, { FC, ReactNode } from 'react'
import { QuestionnaireItem } from '@medplum/fhirtypes'
import { Typography } from 'antd'
import Markdown from 'react-markdown'
import { QUESTIONNAIRE_HELPER_TEXT_EXTENSION_URL } from 'fhir/Questionnaire/constants'

const { Title, Text } = Typography

interface SectionContainerProps {
  subsection: QuestionnaireItem
  displayTitle?: boolean
  children: ReactNode
  titleStyle?: React.CSSProperties
  textStyle?: React.CSSProperties
}

const SectionContainer: FC<SectionContainerProps> = ({
  subsection,
  displayTitle = true,
  children,
  titleStyle,
  textStyle
}) => {
  const defaultTitleStyle = { marginTop: '36px' }
  const finalTitleStyle = titleStyle ? { ...defaultTitleStyle, ...titleStyle } : defaultTitleStyle

  const title = subsection.text
  const helperTextExtension = subsection?.extension?.find(
    (ext) => ext.url === QUESTIONNAIRE_HELPER_TEXT_EXTENSION_URL
  )
  const description = helperTextExtension?.valueCodeableConcept?.coding?.[0]?.display

  return (
    <div key={subsection.linkId}>
      {displayTitle && title && (
        <Title level={4} style={finalTitleStyle}>
          {title}
        </Title>
      )}
      {displayTitle && description && (
        <Text type="secondary" style={textStyle}>
          <Markdown>{description}</Markdown>
        </Text>
      )}
      {children}
    </div>
  )
}

export default SectionContainer
